import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import HomePage from "@/pages/HomePage";
import { WebsitePrivacyPage, WebsiteTermsPage } from "@/pages/WebsiteLegalPages";
import {
  CoachEROverviewPage,
  PrivacyPage,
  TermsPage,
  SupportPage,
  DeleteAccountPage,
} from "@/pages/LegalPages";

const SmoothScroll = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true, anchors: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = undefined;
    };
  }, []);
  return null;
};

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    const lenis = window.__lenis;
    if (hash) {
      const id = window.setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          if (lenis) lenis.scrollTo(el, { offset: -88 });
          else el.scrollIntoView();
        }
      }, 80);
      return () => window.clearTimeout(id);
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <ScrollManager />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<WebsitePrivacyPage />} />
          <Route path="/terms" element={<WebsiteTermsPage />} />
          <Route path="/coacher" element={<CoachEROverviewPage />} />
          <Route path="/coacher/privacy" element={<PrivacyPage />} />
          <Route path="/coacher/terms" element={<TermsPage />} />
          <Route path="/coacher/support" element={<SupportPage />} />
          <Route path="/coacher/delete-account" element={<DeleteAccountPage />} />
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
